import { render } from "./NovaAnaliseIA.vue?vue&type=template&id=6c693bf8"
import script from "./NovaAnaliseIA.vue?vue&type=script&lang=js"
export * from "./NovaAnaliseIA.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__